import { render, staticRenderFns } from "./EditPublishedPaper.vue?vue&type=template&id=51ecf0a1&scoped=true"
import script from "./EditPublishedPaper.vue?vue&type=script&lang=js"
export * from "./EditPublishedPaper.vue?vue&type=script&lang=js"
import style0 from "./EditPublishedPaper.vue?vue&type=style&index=0&id=51ecf0a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ecf0a1",
  null
  
)

export default component.exports